import React, { useEffect, useState } from "react";
import Navbar from "../nav_bar/Navbar";
import {
 FaRegCopy,
 FaCheck,
 FaGift,
 FaUsers,
 FaWhatsapp,
 FaLinkedin,
 FaEnvelope
} from "react-icons/fa";
import "./ReferralPage.css";

const ReferralPage = () => {

 const [user, setUser] = useState(null);

 const [copied, setCopied] = useState({
 code: false,
 link: false
 });

 const referralMessage = `Join Speak Bold with KK and improve your communication skills.

Use my referral link:
${user?.referralLink}

Get free speaking sessions and grow your confidence.
`;

 useEffect(() => {

 const storedUser = localStorage.getItem("user");

 if (storedUser) {
 setUser(JSON.parse(storedUser));
 }

 }, []);

 const handleCopy = (text, type) => {

 navigator.clipboard.writeText(text);

 setCopied(prev => ({
 ...prev,
 [type]: true
 }));

 setTimeout(() => {

 setCopied(prev => ({
 ...prev,
 [type]: false
 }));

 }, 2000);

 };

 const shareWhatsApp = () => {

 window.open(
 `https://wa.me/?text=${encodeURIComponent(referralMessage)}`,
 "_blank"
 );

 };

 const shareLinkedIn = () => {

 window.open(
 `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(user.referralLink)}`,
 "_blank"
 );

 };

 const shareEmail = () => {

 window.open(
 `mailto:?subject=Join Speak Bold with KK&body=${encodeURIComponent(referralMessage)}`
 );

 };

 if (!user) return null;

 return (
 <>
 <Navbar />

 <div className="referral-page">

 <div className="referral-card">

 {/* HEADER */}
 <div className="referral-header">

 <h1>Invite & Earn Free Sessions</h1>

 <p>
 Share your referral link and earn free speaking sessions when your friends join.
 </p>

 </div>


 {/* REFERRAL CODE */}
 <div className="referral-section">

 <label>Referral Code</label>

 <div className="copy-container">

 <span>{user.referralCode}</span>

 <button
 className="copy-button"
 onClick={() => handleCopy(user.referralCode, "code")}
 >
 {copied.code ? <FaCheck /> : <FaRegCopy />}
 </button>

 </div>

 </div>


 {/* REFERRAL LINK */}
 <div className="referral-section">

 <label>Referral Link</label>

 <div className="copy-container">

 <span>{user.referralLink}</span>

 <button
 className="copy-button"
 onClick={() => handleCopy(user.referralLink, "link")}
 >
 {copied.link ? <FaCheck /> : <FaRegCopy />}
 </button>

 </div>

 </div>


 {/* SHARE BUTTONS */}
 <div className="share-section">

 <span>Share via</span>

 <div className="share-buttons">

 <button onClick={shareWhatsApp}>
 <FaWhatsapp /> WhatsApp
 </button>

 <button onClick={shareLinkedIn}>
 <FaLinkedin /> LinkedIn
 </button>

 <button onClick={shareEmail}>
 <FaEnvelope /> Email
 </button>

 </div>

 </div>


 {/* INFO */}
 <div className="referral-info">

 <div className="info-card">

 <FaUsers />

 Friend gets 1 free session

 </div>

 <div className="info-card">

 <FaGift />

 You earn 1 free session after their first session

 </div>

 </div>

 </div>

 </div>

 </>
 );
};

export default ReferralPage;